import { render, staticRenderFns } from "./AddClientAgencyKogi.vue?vue&type=template&id=4b24b572&"
import script from "./AddClientAgencyKogi.vue?vue&type=script&lang=js&"
export * from "./AddClientAgencyKogi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports